<template>
    <div>
        <div class="pt-12 text-center" data-cy="footer">
            <template v-if="isEpicVaultEnabled">
                <div>
                    Copyright &copy; {{ currentYear }} Epic<span :class="currentTextColor">Vault</span>. All Rights
                    Reserved.
                    <span :class="currentTextColor">{{ release_number }}</span>
                </div>
                <a :href="kb_link" target="_blank" :class="currentTextColor">
                    {{ $t('globals.navigation.main.epic_kb_link') }}
                </a>
            </template>
            <template v-else>
                <div>
                    Copyright &copy; {{ currentYear }} Claims<span class="text-default-purple">Vault</span>. All Rights
                    Reserved.
                    <span class="text-default-purple">{{ release_number }}</span>
                </div>
                <a :href="kb_link" target="_blank" class="text-default-purple">
                    {{ $t('globals.navigation.main.claims_kb_link') }}
                </a>
            </template>
        </div>
        <a-back-top />
    </div>
</template>

<script>
export default {
    computed: {
        isEpicVaultEnabled() {
            return this.is_epicvault_enabled ? true : false;
        },
        currentTextColor() {
            let text_color = 'text-default-purple';

            if (this.isEpicVaultEnabled) {
                switch (this.state_link) {
                    case 'claim':
                        text_color = 'text-default-purple';
                        break;
                    case 'cover':
                        text_color = 'text-default-blue-green';
                        break;
                    default:
                        text_color = 'text-default-blue';
                        break;
                }
            }

            return text_color;
        },
        currentYear() {
            return this.$dayjs().format('YYYY');
        },
    },
    data() {
        return {
            kb_link: window.kb_access,
            release_number: window.release_number,
        };
    },
    props: {
        is_epicvault_enabled: {
            type: Boolean,
            default: false,
        },
        state_link: {
            type: String,
            default: 'default',
        },
    },
};
</script>
